import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-white py-10 sm:py-14" data-id="element-179" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-180" data-mp="1t8niy08x17ou">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ink/10' : ''}`} data-id="element-181" data-mp="1jd3pdkhtql39" data-mpi={index}>
            <dt className="sr-only" data-id="element-182" data-mp="19mr7k01e960t">{stat.label}</dt>
            <dd data-id="element-183" data-mp="19ky0ijmvcjsa">
              <span className="block font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-184" data-mp="19keh0yhklnc5">
                {stat.value}
              </span>
              <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-ink/50 sm:text-xs" data-id="element-185" data-mp="10mcgsl5nuypx">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}